import React from "react";

export const Thumbnail = (props) => {
	const { url, width, height } = props.visuel;
	const { x, y } = props.position;

	const styles = {
		// transform: `translate(${x}px, ${y}px)`,
		// transform: `translateY(${y}px)`,
		opacity: `${!url || !props.Visible ? 0 : 1}`,
	};

	return (
		<div className="visuel" style={styles}>
			<img src={url} width={width} alt="visuel" height={height} />
		</div>
	);
};
